/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-empty */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/button-has-type */
/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import queryString from 'query-string';
import React from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tippy';

import { isMobile } from 'react-device-detect';
import ReCAPTCHA from 'react-google-recaptcha';
import { authenticate, changePassword, logout } from '../../app/store/actions/auth';
import { mergeCart } from '../../app/store/actions/cart';
import { selectContract } from '../../app/store/actions/contracts';
import { recoverPassword } from '../../app/store/actions/solicitation';
import inputSize from '../../data/inputs';
import ProductsData from '../../data/products';
import ROUTES from '../../data/routes';
import { history } from '../../routers/AppRouter';
import PasswordPolicy from '../changePassword/PasswordPolicy';
import { appendScript, removeScript } from '../utils';
import HeaderCartMenu from './HeaderCartMenu';

import 'react-tippy/dist/tippy.css';
import { getSuggests } from '../../app/store/actions/products';
import HeaderSuggests from './HeaderSuggests';
import MobileMenu from './MobileNavMenuCategories';
import NavMenuCategories from './NavMenuCategories';

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.closeLeftMenuButton = React.createRef();

    this.openSideLoginButton = React.createRef();
    this.closeSideLoginButton = React.createRef();

    this.openCartMenuButton = React.createRef();
    this.closeCartMenuButton = React.createRef();

    this.state = {
      email: '',
      password: '',
      error: '',
      passwordToChange: '',
      message: '',
      confirmPassword: '',
      oldPassword: '',
      maxSubMenuInBottom: ProductsData.maxSubMenuInBottom, // 5 sub
      renderMenuType: 'login',
      text: '',
      dismissedClick: false,
      emailToRecover: '',
      color: true,
      reCaptchaVerify: false,
      showTooltipPassword: false,
      passwordValidity: {
        minChar: null,
        number: null,
        upperCase: null,
        specialChar: null,
      },
      searchFilterText: '',
      cartType: '',
      categoriesSearch: '',
    };
  }

  componentDidMount = () => {
    removeScript('/scripts/default.min.js');
    appendScript('/scripts/default.min.js');

    this.setSearch();
    this.initHistoryListen();

    document.body.addEventListener('click', this.onClickBody);
  };

  componentWillReceiveProps = async (nextProps) => {
    const { contractsTotal, isAuthenticated, isPunchOut } = nextProps;
    const contractsTotalChanged = contractsTotal !== this.props.contractsTotal;
    const authChanged = this.props.isAuthenticated !== isAuthenticated;
    if (isAuthenticated) {
      if (contractsTotalChanged && contractsTotal > 1) {
        this.setState({ renderMenuType: 'contracts', error: '' });
      } else if (contractsTotalChanged) {
        this.closeSideLogin();
      } else {
        this.reloadHeaderJs();
      }
    } else if (!isAuthenticated) {
      this.setState({ renderMenuType: 'login', error: '' });
    }

    if (
      !isPunchOut
      && authChanged
      && history.location.pathname !== ROUTES.HOME
    ) {
      this.reloadHeaderJs();
      history.push(ROUTES.HOME);
    }
  };

  componentDidUpdate = (prevProps, prevStates) => {
    const validUpdateState = !(
      prevStates.email !== this.state.email
      || prevStates.password !== this.state.password
      || prevStates.error !== this.state.error
      || prevStates.maxSubMenuInBottom !== this.state.maxSubMenuInBottom
      || prevStates.renderMenuType !== this.state.renderMenuType
      || prevStates.text !== this.state.text
    );

    if (validUpdateState) {
      if (history.location.pathname === ROUTES.HOME) {
        setTimeout(() => this.reloadHeaderJs(), 1000);
      }
      if (!this.state.hadChange && history.location.pathname !== ROUTES.PRODUCTS) {
        this.clearSearch();
      }
    }
    if (prevStates.text !== this.state.text) {
      const clientId = this.props.isAuthenticated ? this.props.clientId : undefined;
      this.onGetSuggests(this.state.text, clientId);
    }
  };

  componentWillUnmount = () => {
    removeScript('/scripts/default.min.js');
    document.body.addEventListener('click', this.onClickBody);
  };

  onGetSuggests = _.debounce((term, client) => {
    this.props.getSuggests(term, client);
  }, 400);

  initHistoryListen = () => {
    try {
      history.listen(this.historyListen);
    } catch (e) {}
  };

  historyListen = (location) => {
    if (
      location.pathname === ROUTES.PRODUCTS
      && !queryString.parse((location.search || '').replace(/[+]/g, '%2B')).text
    ) {
      this.clearSearch();
    }
  };

  reloadHeaderJs = () => {
    removeScript('/scripts/default.min.js');
    appendScript('/scripts/default.min.js');
  };

  onClickBody = () => this.setState({ dismissedClick: true });

  onEmailChange = (e) => {
    const email = e.target.value;
    this.setState(() => ({ email }));
  };

  onPasswordChange = (e) => {
    const password = e.target.value;
    this.setState(() => ({ password }));
  };

  onReCaptchaChange = () => this.setState({ reCaptchaVerify: true });

  onReCaptchaExpired = () => this.setState({ reCaptchaVerify: false });

  onChangePassword = (password) => {
    const characterLengthRegex = /^.{9,}$/;
    const isNumberRegex = /[0-9]/;
    const specialCharacterRegex = /[!@#$%^&*]/;
    const upperCaseCharacterRegex = /[A-Z]/;
    this.setState({
      passwordToChange: password,
      message: '',
      success: '',
      passwordValidity: {
        minChar: characterLengthRegex.test(password),
        number: isNumberRegex.test(password),
        upperCase: upperCaseCharacterRegex.test(password),
        specialChar: specialCharacterRegex.test(password),
      },
    });
  };

  onSubmitLogin = async (e) => {
    e.preventDefault();
    if (this.state.email && this.state.password) {
      try {
        await this.props.authenticate(this.state.email, this.state.password);
        window.scrollTo(0, 0);
        this.setState({ error: '' });
      } catch (error) {
        const errorData = !!(error.response && error.response.data);
        if (error.response.status && error.response.status === 429) {
          this.setState({
            error: `${I18n.t('requestLimit')} ${
              error.response.data.rateLimit.resetTime
            } ${I18n.t('minutes')}`,
          });
        } else if (errorData && error.response.data.error.code === 209) {
          this.setState({ error: I18n.t('userBlocked') });
        } else if (errorData && error.response.data.error.code === 211) {
          this.setState({ error: I18n.t('userHasNoActiveContract') });
        } else if (errorData && error.response.data.error.code === 407) {
          this.setState({ error: I18n.t('userInvalidPassword') });
        } else if (errorData && error.response.data.error.code === 412) {
          this.setState({ error: I18n.t('userInvalidPasswordPolicy') });
        } else {
          this.setState({ error: I18n.t('invalidLogin') });
        }
      }
    }
  };

  showContractsSideMenu = () => {
    this.hideChat();
    this.setState({
      renderMenuType: 'contracts',
      error: '',
      searchFilterText: '',
    });
    $('.openLogin').click();
    $('.login-submenu').removeClass('active');
  };

  newRegister = () => {
    this.closeSideLogin();
    history.push(ROUTES.NEW_REGISTER);
  };

  solicitation = () => {
    this.closeSideLogin();
    history.push(ROUTES.SOLICITATION);
  };

  recoverPw = (e) => {
    if (e) e.preventDefault();
    this.setState({ renderMenuType: 'recoverpw' });
  };

  pushAndCloseLeftMenu = (route) => {
    this.closeLeftMenu();
    history.push(route);
  }

  closeLeftMenu = () => {
    if (this.closeLeftMenuButton.current) this.closeLeftMenuButton.current.click();
  }

  openSideLogin = () => {
    if (this.openSideLoginButton.current) this.openSideLoginButton.current.click();
  };

  closeSideLogin = () => {
    if (this.closeSideLoginButton.current) this.closeSideLoginButton.current.click();
  };

  openCartMenu = () => {
    this.hideChat();
    if (this.openCartMenuButton.current) this.openCartMenuButton.current.click();
  };

  closeCartMenu = () => {
    this.showChat();
    if (this.closeCartMenuButton.current) this.closeCartMenuButton.current.click();
  };

  openFavorite = () => {
    this.setState({ cartType: 'favorite' }, () => {
      $('.openCart').click();
      this.hideChat();
    });
  };

  showChat = () => {
    try {
      const { huggy, blipChatKey } = this.props;

      if (huggy) {
        const chatEl = document.getElementsByClassName(
          'powerzap_open_button_iframe',
        );
        if (chatEl.length && getCookieConsentValue('CookieLGPD')) chatEl[0].style.display = null;
      } else if (blipChatKey) {
        const chatEl = document.getElementById('blip-chat-container');
        if (chatEl && getCookieConsentValue('CookieLGPD')) chatEl.style.display = null;
      }

      this.setState({ cartType: '' });
    } catch (e) {}
  };

  hideChat = () => {
    try {
      const { huggy, blipChatKey } = this.props;

      if (huggy) {
        const chatEl = document.getElementsByClassName(
          'powerzap_open_button_iframe',
        );
        if (chatEl.length) chatEl[0].style.display = 'none';
      } else if (blipChatKey) {
        const chatEl = document.getElementById('blip-chat-container');
        if (chatEl) chatEl.style.display = 'none';
      }
    } catch (e) {}
  };

  checkMergeCart = (side) => {
    this.showChat();
    if (this.props.isAuthenticated && side === 'sideLogin') {
      this.props.mergeCart();
    }

    setTimeout(
      () => this.setState({
        ...(!this.props.isAuthenticated ? { renderMenuType: 'login' } : {}),
        success: '',
        message: '',
        passwordToChange: '',
        confirmPassword: '',
        oldPassword: '',
        emailToRecover: '',
        color: true,
      }),
      1000,
    );
  };

  passwordChange = () => {
    this.setState({ renderMenuType: 'changepw' });
    $('.openLogin').click();
  };

  onSubmitChangePw = async (e) => {
    e.preventDefault();
    const { passwordToChange, confirmPassword, oldPassword } = this.state;

    if (!(passwordToChange, confirmPassword, oldPassword)) return;

    const { passwordValidity } = this.state;

    if (!passwordValidity.minChar) {
      this.setState({ message: I18n.t('passwordErrorMinChar'), success: '' });
      return;
    }
    if (!passwordValidity.number) {
      this.setState({ message: I18n.t('passwordErrorNumber'), success: '' });
      return;
    }
    if (!passwordValidity.upperCase) {
      this.setState({ message: I18n.t('passwordErrorUpperCase'), success: '' });
      return;
    }
    if (!passwordValidity.specialChar) {
      this.setState({
        message: I18n.t('passwordErrorSpecialChar'),
        success: '',
      });
      return;
    }

    if (
      passwordToChange
      && confirmPassword
      && passwordToChange !== confirmPassword
    ) {
      this.setState({ message: I18n.t('passwordDifferents'), success: '' });
      return;
    }

    try {
      await this.props.changePassword(passwordToChange, oldPassword);
      this.setState({
        success: I18n.t('passwordSuccessChanged'),
        message: '',
        passwordToChange: '',
        confirmPassword: '',
        oldPassword: '',
        showTooltipPassword: false,
        passwordValidity: {
          minChar: null,
          number: null,
          upperCase: null,
          specialChar: null,
        },
      });
    } catch (error) {
      if (error.response.status && error.response.status === 429) {
        this.setState({
          message: `${I18n.t('requestLimit')} ${
            error.response.data.rateLimit.resetTime
          } ${I18n.t('minutes')}`,
          success: '',
        });
      } else {
        this.setState({ message: I18n.t('passwordInvalid'), success: '' });
      }
    }
  };

  // envio de email para resetar a senha
  onSubmitRecoverPw = async (e) => {
    e.preventDefault();
    if (this.state.emailToRecover) {
      const recover = await this.props.recoverPassword(
        this.state.emailToRecover,
      );
      if (recover && typeof recover === 'boolean') {
        this.setState({
          color: true,
          message: I18n.t('recoverPasswordResponseMsg'),
        });
      } else if (
        recover.response
        && recover.response.status
        && recover.response.status === 429
      ) {
        this.setState({
          color: false,
          message: `${I18n.t('requestLimit')} ${
            recover.response.data.rateLimit.resetTime
          } ${I18n.t('minutes')}`,
        });
      } else {
        this.setState({
          color: false,
          message: I18n.t('recoverPasswordResponseMsg'),
        });
      }
    }
  };

  userLogout = async () => {
    try {
      await this.props.logout();
    } finally {
      this.reloadHeaderJs();
      if (history.location.pathname !== ROUTES.HOME) {
        history.push(ROUTES.HOME);
      }
    }
  };

  setSearch = () => {
    const params = queryString.parse(this.props.location.search);

    this.setState({ text: params.text || '', categoriesSearch: params.categories || '', search: params });
  }

  setSearchText = () => {
    const params = queryString.parse(this.props.location.search);

    this.setState({ text: params.text || '' });
  };

  clearSearch = () => this.setState({ text: '', categoriesSearch: '' });

  setSuggest = async (e, sug) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ text: sug, dismissedClick: true });
    await this.onSubmit(undefined, sug);
  }

  historyListen = (location) => {
    if (
      !this.state.hadChange
      && location.pathname === ROUTES.PRODUCTS
      && !(queryString.parse((location.search || '').replace(/[+]/g, '%2B')).text)
    ) {
      this.clearSearch();
    }
  }

  hasText = () => queryString.parse((this.props.location.search || '').replace(/[+]/g, '%2B'))
    .text;

  showDidYouMean = (suggest, productsList, dismissedClick) => !!(suggest && suggest.length)
    && !!this.hasText()
    && !(productsList && productsList.length)
    && !dismissedClick;

  onSubmit = async (e, sug = '') => {
    if (e) e.preventDefault();
    const { text, categoriesSearch } = this.state;

    let url = `${ROUTES.PRODUCTS}?`;
    if (sug || text || categoriesSearch) url += `text=${sug || text}&categories=${categoriesSearch || ''}&`;
    this.setState({ hadChange: false });
    history.push(url);
    setTimeout(() => this.setState({ dismissedClick: false }), 1000);
  };

  onSelectContract = async (index, isRightMenu) => {
    const { contractSelected } = this.props;
    if (contractSelected && contractSelected.index !== index) {
      await this.props.selectContract(index);
    } else this.checkMergeCart('sideLogin');

    if (isRightMenu) this.closeSideLogin();
    if (history.location.pathname !== ROUTES.HOME) history.push(ROUTES.HOME);
  };

  onClickCog = () => {
    try {
      $('.nav-logged.sub').toggleClass('active');
    } catch (e) {}
  };

  getCategoriesWithOrder = (categories = []) => {
    try {
      let ordersInAcum = 0;
      const maxCategories = ProductsData.maxSubMenuInBottom + 1;
      const categoriesOrdered = categories.reduce((acum, category) => {
        if (ordersInAcum < maxCategories) {
          const orderId = parseInt(category.order, 10);
          if (orderId) {
            acum.push(category);
            ordersInAcum++;
          }

          if (category.categories) {
            category.categories.forEach((subCategory) => {
              if (ordersInAcum < maxCategories) {
                const orderIdSub = parseInt(subCategory.order, 10);
                if (orderIdSub) {
                  acum.push(subCategory);
                  ordersInAcum++;
                }
              }
            });
          }
        }

        return acum;
      }, []);

      return categoriesOrdered;
    } catch (e) {}

    return [];
  };

  renderHeaderLogged = (
    user = {},
    contracts = {},
    panelPermission,
    isPunchOut,
  ) => {
    const pendingSolicitations = user.multiApprove
      ? contracts.list.reduce(
        (total, contract) => total + parseFloat(contract.pendingSolicitations || 0),
        0,
      )
      : (contracts.selected && contracts.selected.pendingSolicitations) || 0;

    return (
      <div className="header-logged">
        <div className="container container-header-logged">
          <a className="nav-logged header-updated" href="#">
            {`${I18n.t(
              'welcome',
            )}, ${user.name}!`}
          </a>
          {panelPermission && (
            <Link to={ROUTES.ORDER_LIST} className="nav-logged header-updated">
              {pendingSolicitations ? (
                <span className="number">{pendingSolicitations}</span>
              ) : (
                ''
              )}
              {I18n.t('panel')}
            </Link>
          )}
          {!isPunchOut && (
            <div className="nav-logged sub" onClick={this.onClickCog}>
              <a className="nav-logged">
                <svg className="icon icon-cog">
                  <use xlinkHref="#icon-cog" />
                </svg>
              </a>
              <div className="subnav-logged">
                <a onClick={this.passwordChange}>{I18n.t('passwordChange')}</a>
                <a onClick={this.userLogout}>{I18n.t('exit')}</a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  checkSustainable = (category, left = false) => {
    if (left && category.isSustainable) return { flex: 5, color: '#00b200' };
    if (category.isSustainable) return { color: '#00b200' };
  };

  renderLeftMenuCategories = (categories = []) => (
    <div className="box-aside contentBoxNav contentBoxFixed box-fixed box-fixed__nav">
      <button
        ref={this.closeLeftMenuButton}
        type="button"
        className="box-fixed__close closeBoxFixed"
      >
        {I18n.t('close')}
      </button>
      <div className="box-fixed__title">

        {!this.props.isAuthenticated && (
        <div className="box-aside-title openLogin">
          <div className="user">
            {`${I18n.t('hello')}, `}
            <strong>{I18n.t('identify')}</strong>
            <p style={{ textAlign: 'center' }}>
              {I18n.t('login')}
            </p>
          </div>
        </div>
        )}

        {this.props.isAuthenticated && (
        <span className="box-aside-title">
          <span className="user">
            {`${I18n.t('hello')}, `}
            <strong>{this.props.user && this.props.user.name}</strong>
          </span>
        </span>
        )}

      </div>

      <div className="nav-mob">
        <ul className="nav-ul">
          <MobileMenu
            categories={categories}
            forwardedRef={this.closeLeftMenuButton}
            pushAndCloseLeftMenu={this.pushAndCloseLeftMenu}
          />
        </ul>
      </div>
      <span className="overflow closeBoxFixed" />
    </div>
  )

  renderSideCart = () => (
    <HeaderCartMenu
      history={history}
      openSideLogin={this.openSideLogin}
      closeCartMenu={this.closeCartMenu}
      closeCartMenuButton={this.closeCartMenuButton}
      showChat={this.showChat}
      cartType={this.state.cartType}
    />
  );

  renderLoginCad = (isAuthenticated, contracts) => (isAuthenticated ? (
    <div className="login logged">
      <a className="link" onClick={this.showContractsSideMenu}>
        <svg className="icon icon-user">
          <use xlinkHref="#icon-user" />
        </svg>
        <span className="text">
          <b>{I18n.t('myAccount')}</b>
          {contracts.selected
            ? contracts.selected.clientDetails.nickname
                || contracts.selected.client.name
            : I18n.t('withOutContract')}
          {' '}
          <span className="ico-sub" />
        </span>
      </a>
      {!!contracts.list && (
      <span className="login-submenu scroll-custom-nortel">
        {contracts.list.map((contract, index) => (
          <a
            key={`${
              contract.clientDetails.nickname || contract.client.name
            }${index}`}
            style={{ cursor: 'pointer' }}
            onClick={() => this.onSelectContract(contract.index)}
            onKeyDown={() => this.onSelectContract(contract.index)}
            role="presentation"
          >
            {contract.pendingSolicitations ? (
              <span className="number">
                {contract.pendingSolicitations}
              </span>
            ) : (
              ''
            )}
            {contract.clientDetails.nickname || contract.client.name}
          </a>
        ))}
      </span>
      )}
    </div>
  ) : (
    <div className="login">
      <a
        ref={this.openSideLoginButton}
        className="link openLogin"
        onClick={this.hideChat}
      >
        <svg className="icon icon-user">
          <use xlinkHref="#icon-user" />
        </svg>
        <span className="text">
          <b>{I18n.t('myAccount')}</b>
          {`${I18n.t('login')} ∙ ${I18n.t('loginCadNew')}`}
        </span>
      </a>
    </div>
  ));

  renderSideLogin = () => (
    <React.Fragment>
      <span className="box-fixed__title">{I18n.t('loginIdentify')}</span>
      <form className="login-form">
        <p className="description">{I18n.t('loginInfoEmail')}</p>
        {this.state.error && <p className="error-msg">{this.state.error}</p>}
        <label className="label">
          {I18n.t('email')}
          <input
            type="email"
            className="input"
            placeholder={I18n.t('emailPlaceholder')}
            value={this.state.email}
            onChange={this.onEmailChange}
            maxLength={inputSize.max}
            required
          />
        </label>
        <label className="label">
          {I18n.t('password')}
          <input
            type="password"
            className="input"
            placeholder={I18n.t('passwordPlaceholder')}
            value={this.state.password}
            onChange={this.onPasswordChange}
            maxLength={inputSize.maxPassword}
            required
            onKeyPress={e => e.key === 'Enter' && this.onSubmitLogin(e)}
          />
        </label>
        {window.location.hostname !== 'localhost' && (
          <ReCAPTCHA
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
            }}
            sitekey={this.props.keyReCaptcha}
            onChange={this.onReCaptchaChange}
            onExpired={this.onReCaptchaExpired}
          />
        )}
        <span className="line" />
        <button
          type="button"
          className="btn-form"
          disabled={
            window.location.hostname !== 'localhost'
            && !this.state.reCaptchaVerify
          }
          onClick={this.onSubmitLogin}
        >
          {I18n.t('entry')}
        </button>
        {this.props.onTotvs ? (
          <button type="button" className="btn-form" onClick={this.newRegister}>
            {I18n.t('loginNewRegister')}
          </button>
        ) : (
          <button
            type="button"
            className="btn-form"
            onClick={this.solicitation}
          >
            {I18n.t('loginRegisterSolicitation')}
          </button>
        )}
        <a onClick={this.recoverPw} className="btn-pass cursorPointer">
          {I18n.t('forgotPassword2')}
        </a>
      </form>
    </React.Fragment>
  );

  renderContractList = (contracts, contractSelected, searchFilterText) => {
    const contractsToRender = (contracts.list || []).filter((contract) => {
      if (!searchFilterText) return true;
      let data = '';
      if (contract.clientDetails.nickname) data += ` ${contract.clientDetails.nickname.toLowerCase()}`;
      Object.keys(contract.client).forEach((key) => {
        if (contract.client[key].toLowerCase) data += ` ${contract.client[key].toLowerCase()}`;
      });
      return data.search(searchFilterText) !== -1;
    });

    return (
      !!contractsToRender
      && contractsToRender.map(contract => (
        <a
          key={contract.index}
          className="contrato"
          style={{
            cursor: 'pointer',
            ...(contractSelected.index === contract.index
              ? { backgroundColor: '#009FEC' }
              : {}),
          }}
          onClick={() => this.onSelectContract(contract.index, true)}
          onKeyDown={() => this.onSelectContract(contract.index, true)}
          role="presentation"
        >
          <span
            className="title"
            style={{
              ...(contractSelected.index === contract.index
                ? { color: '#fff' }
                : {}),
            }}
          >
            {contract.client.name}
          </span>
          <span
            className="subtitle"
            style={{
              ...(contractSelected.index === contract.index
                ? { color: '#fff' }
                : {}),
            }}
          >
            {contract.clientDetails.nickname}
          </span>
          <span
            className="txt"
            style={{
              ...(contractSelected.index === contract.index
                ? { color: '#fff' }
                : {}),
            }}
          >
            {contract.client.id}
          </span>
          <span
            className="txt"
            style={{
              ...(contractSelected.index === contract.index
                ? { color: '#fff' }
                : {}),
            }}
          >
            {`${contract.client.city}, ${contract.client.state}`}
          </span>
        </a>
      ))
    );
  };

  renderContracts = (
    contracts = {},
    contractSelected = {},
    searchFilterText = '',
  ) => (
    <React.Fragment>
      <span className="box-fixed__title">{I18n.t('contracts')}</span>
      <div className="contratos">
        <p className="description">
          {I18n.t('contractSelect')}
          {' '}
          <br />
          {I18n.t('contractSelectDown')}
        </p>
        <div style={{ marginBottom: 30 }}>
          <form className="login-form">
            <input
              type="text"
              className="input"
              placeholder={I18n.t('search')}
              maxLength={100}
              value={searchFilterText}
              onChange={e => this.setState({ searchFilterText: e.target.value })
              }
            />
          </form>
        </div>
        {this.renderContractList(contracts, contractSelected, searchFilterText)}
      </div>
    </React.Fragment>
  );

  renderChangePw = () => (
    <React.Fragment>
      <span className="box-fixed__title">{I18n.t('passwordChange')}</span>
      <form className="login-form">
        <p className="description">{I18n.t('passwordChangeHeader')}</p>

        <label className="label">
          {I18n.t('currentPassword')}
          <input
            type="password"
            className="input"
            placeholder={I18n.t('currentPassword')}
            maxLength={inputSize.maxPassword}
            value={this.state.oldPassword}
            onChange={e => this.setState({
              oldPassword: e.target.value,
              message: '',
              success: '',
            })
            }
            required
          />
        </label>

        <label className="label">
          <div>
            <Tooltip
              open={this.state.showTooltipPassword}
              theme="light"
              position="top-start"
              popperOptions={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                  flip: {
                    enabled: false,
                  },
                },
              }}
              html={(
                <PasswordPolicy
                  className="form-control"
                  validity={this.state.passwordValidity}
                  passwordEqual={
                    this.state.passwordToChange
                      === this.state.confirmPassword && this.state.confirmPassword
                  }
                />
              )}
            >
              <div />
            </Tooltip>
          </div>
          {I18n.t('newPassword')}
          <input
            type="password"
            className="input"
            placeholder={I18n.t('newPassword')}
            maxLength={inputSize.maxPassword}
            value={this.state.passwordToChange}
            onChange={e => this.onChangePassword(e.target.value)}
            onFocus={() => this.setState({ showTooltipPassword: true })}
            onBlur={() => this.setState({ showTooltipPassword: false })}
            required
          />
        </label>

        <label className="label">
          {I18n.t('confirmNewPassword')}
          <input
            type="password"
            className="input"
            placeholder={I18n.t('confirmNewPassword')}
            maxLength={inputSize.maxPassword}
            value={this.state.confirmPassword}
            onChange={e => this.setState({
              confirmPassword: e.target.value,
              message: '',
              success: '',
            })
            }
            onFocus={() => this.setState({ showTooltipPassword: true })}
            onBlur={() => this.setState({ showTooltipPassword: false })}
            required
          />
        </label>

        <span className="line" />

        <button
          type="button"
          className="btn-form"
          onClick={this.onSubmitChangePw}
        >
          {I18n.t('passwordChange')}
        </button>
        <p className="error-msg">{this.state.message}</p>
        <p className="success-msg">{this.state.success}</p>
      </form>
    </React.Fragment>
  );

  renderRecoverPw = () => (
    <React.Fragment>
      <span className="box-fixed__title">{I18n.t('recoverPassword')}</span>
      <form className="login-form">
        <p className="description">{I18n.t('recoverPasswordHeader')}</p>

        <label className="label">
          {I18n.t('email')}
          <input
            type="text"
            className="input"
            maxLength={inputSize.max}
            placeholder={I18n.t('email')}
            value={this.state.emailToRecover}
            onChange={e => this.setState({ emailToRecover: e.target.value })}
            required
            onKeyPress={e => e.key === 'Enter' && this.onSubmitRecoverPw(e)}
          />
        </label>

        <span className="line" />

        <button
          type="button"
          className="btn-form"
          onClick={this.onSubmitRecoverPw}
        >
          {I18n.t('recoverPassword')}
        </button>
        <a
          className="btn-pass cursorPointer"
          onClick={() => this.setState({ renderMenuType: 'login' })}
        >
          {I18n.t('entry')}
        </a>
        <p className={this.state.color ? 'success-msg' : 'error-msg'}>
          {this.state.message}
        </p>
      </form>
    </React.Fragment>
  );

  renderHeaderFavoriteIcon = (favoritesItems = []) => (
    <div className="favorite">
      <a className="link" onClick={this.openFavorite}>
        {favoritesItems.length > 0 && (
          <span className="itens">{favoritesItems.length}</span>
        )}
        <svg className="icon icon-favorite">
          <use xlinkHref="#icon-star" />
        </svg>
      </a>
    </div>
  );

  renderHeaderCartIcon = (cartItems = []) => (
    <div className="cart">
      <a
        ref={this.openCartMenuButton}
        className="link openCart"
        onClick={this.hideChat}
      >
        {cartItems.length > 0 && (
          <span className="itens">{cartItems.length}</span>
        )}
        <svg className="icon icon-cart">
          <use xlinkHref="#icon-cart" />
        </svg>
      </a>
    </div>
  );

  render() {
    const {
      settings = {},
      isAuthenticated,
      user,
      contracts = {},
      isPunchOut = false,
      panelPermission = false,
      cartPermission,
      cartItems,
      suggest,
      productsList,
      contractSelected,
      favoritesItems,
    } = this.props;
    const {
      categories, email, logo, contactUs, phone, whatsapp,
    } = settings;
    const {
      renderMenuType, text, dismissedClick, searchFilterText,
      categoriesSearch,
    } = this.state;

    return (
      <React.Fragment>
        {isAuthenticated
          && this.renderHeaderLogged(user, contracts, panelPermission, isPunchOut)}
        <header className="header">
          <div className="container container-header">
            <div className="logo" style={{ width: 203 }}>
              <Link
                className="link"
                to={ROUTES.HOME}
                style={{ backgroundImage: `url(${logo})` }}
              />
            </div>
            <div className="search" style={{ marginLeft: '55px', marginTop: isMobile ? '20px' : '', padding: isMobile }}>
              <form onSubmit={this.onSubmit} className="search-form">
                <select
                  name=""
                  className="search-select"
                  style={{ fontFamily: '"Roboto", sans-serif' }}
                  value={categoriesSearch}
                  onChange={e => this.setState({ categoriesSearch: e.target.value, hadChange: true })}
                >
                  <option key="all" value="">{I18n.t('all')}</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>{category.name}</option>
                  ))}
                </select>

                <input
                  type="text"
                  className="input"
                  placeholder={I18n.t('searchProduct')}
                  maxLength={inputSize.maxDefault}
                  value={this.state.text}
                  onChange={(e) => {
                    this.setState({ text: e.target.value, hadChange: true, dismissedClick: false });
                  }}
                  onClick={() => { this.setState({ dismissedClick: !this.state.dismissedClick }); }}
                />
                <button type="submit" className="button">
                  <svg className="icon icon-search">
                    <use xlinkHref="#icon-search" />
                  </svg>
                </button>
              </form>
              <HeaderSuggests dismissedClick={dismissedClick} setSuggest={this.setSuggest} term={text} style={{ width: '100%' }} />
              {!!(suggest && suggest.length)
                  && suggest.map(sug => (
                    <a
                      key={sug}
                      className="cursorPointer"
                      onClick={() => this.setSuggest(sug)}
                    >
                      {sug}
                    </a>
                  ))}
            </div>
            <div className="call" style={{ marginRight: '15px' }}>
              {contactUs === 'email' && (
                <a className="link" href={`mailto:${email}`}>
                  <svg className="icon icon-whatsapp">
                    <use xlinkHref="#icon-mail" />
                  </svg>
                  <span className="text">
                    <b>{I18n.t('contactUs')}</b>
                    {email}
                  </span>
                </a>
              )}
              {contactUs === 'whatsapp' && (
                <a
                  className="link"
                  href={`https://api.whatsapp.com/send?phone=55${whatsapp.replace(
                    /[^0-9]/g,
                    '',
                  )}`}
                  target="_blank"
                >
                  <svg className="icon icon-whatsapp">
                    <use xlinkHref="#icon-whatsapp" />
                  </svg>
                  <span className="text">
                    <b>{I18n.t('contactUs')}</b>
                    {whatsapp}
                  </span>
                </a>
              )}
              {contactUs === 'phone' && (
                <a
                  className="link"
                  href={`tel:${phone.replace(/[^0-9]/g, '')}`}
                >
                  <svg className="icon icon-whatsapp">
                    <use xlinkHref="#icon-phone" />
                  </svg>
                  <span className="text">
                    <b>{I18n.t('contactUs')}</b>
                    {phone}
                  </span>
                </a>
              )}
            </div>

            {contractSelected
              && contractSelected.clientDetails
              && contractSelected.clientDetails.completeLogoUrl && (
                <div
                  className="logo"
                  style={{
                    marginRight: '35px',
                    width: '100px',
                    height: '60px',
                  }}
                >
                  <img
                    src={
                      contractSelected.clientDetails.completeLogoUrl
                      || 'images/default-image.jpg'
                    }
                    style={{ height: '60px', width: '100px' }}
                    alt="Logo do cliente"
                  />
                </div>
            )}

            {this.renderLoginCad(isAuthenticated, contracts)}
            {((isAuthenticated && cartPermission) || !isAuthenticated)
              && this.renderHeaderCartIcon(cartItems)}
            {isAuthenticated && this.renderHeaderFavoriteIcon(favoritesItems)}
          </div>
        </header>
        <nav className="nav-main">
          <div className="container container-nav">
            {isMobile && (
              <React.Fragment>
                <button type="button" className="nav-button openNav">
                  <span />
                </button>
                <div className="header-mob">
                  <div className="container" />
                </div>
              </React.Fragment>
            )}
            <ul className="nav">
              <NavMenuCategories categories={categories} />
            </ul>
          </div>
        </nav>

        {isMobile && (this.renderLeftMenuCategories(categories))}

        {((isAuthenticated && cartPermission) || !isAuthenticated)
          && this.renderSideCart()}
        <div className={`box-fixed box-fixed--right box-fixed__login ${!isAuthenticated ? 'active' : ''} `}>
          <button
            ref={this.closeSideLoginButton}
            type="button"
            className="box-fixed__close closeBoxFixed"
            onClick={() => this.checkMergeCart('sideLogin')}
          >
            {I18n.t('close')}
          </button>
          {renderMenuType === 'login' && this.renderSideLogin()}
          {renderMenuType === 'contracts'
            && this.renderContracts(contracts, contractSelected, searchFilterText)}
          {renderMenuType === 'recoverpw' && this.renderRecoverPw(contracts)}
          {renderMenuType === 'changepw' && this.renderChangePw()}
          <span
            className="overflow closeBoxFixed"
            onClick={() => this.checkMergeCart('sideLogin')}
          />
          <div
            className="link openLogin"
            style={{ display: 'none', pointerEvents: 'none' }}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  isAuthenticated: state.auth.authenticated,
  contractsTotal: state.contracts.list.length,
  onTotvs: !!((state.settings.urlWsTotvs && state.settings.urlWsTotvs !== '')),
  punchOutData: state.punchOut,
  user: state.auth.user,
  contracts: state.contracts,
  contractSelected: state.contracts.selected,
  panelPermission: state.contracts.selected && state.contracts.selected.panelPermission,
  cartPermission: state.contracts.selected && state.contracts.selected.cartPermission,
  cartItems: state.cart.items,
  favoritesItems: state.favorites.items,
  productsList: state.products.list,
  suggest: state.products.suggest,
  isPunchOut: state.punchOut,
  huggy: state.settings.huggyParams,
  blipChatKey: state.settings.blipChatKey,
  keyReCaptcha: state.settings.keyReCaptcha,
});

const mapDispatchToProps = dispatch => ({
  authenticate: (email, password) => dispatch(authenticate(email, password)),
  mergeCart: () => dispatch(mergeCart()),
  logout: () => dispatch(logout()),
  selectContract: index => dispatch(selectContract(index)),
  changePassword: (password, oldPassword) => dispatch(changePassword(password, oldPassword)),
  recoverPassword: email => dispatch(recoverPassword(email)),
  getSuggests: (term, client) => dispatch(getSuggests(term, client)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Header);
